import { Link } from "react-router";
import {
  LANDING_ASSETS,
  LANDING_PAYMENT_SUCCESS_TYPOGRAPHY,
  LANDING_SUPPORT,
} from "../constants/landing.constants";

interface PaymentSuccessCardProps {
  email: string;
}

export default function PaymentSuccessCard({ email }: PaymentSuccessCardProps) {
  return (
    <div className={LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.card}>
      <img
        src={LANDING_ASSETS.paymentSuccessBadge}
        alt=""
        className="mx-auto mb-6 h-[96px] w-[96px] object-contain"
        aria-hidden
      />

      <h1 className={LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.title}>
        Payment Successful!
      </h1>

      <p className={LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.body}>
        Your payment is complete and your account is ready. You can sign up /
        sign in to the portal using your email address{" "}
        <strong className="font-semibold text-landing-text">{email}</strong>.
      </p>

      <hr className="mb-6 border-landing-border" />

      <p className={LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.support}>
        If you do not receive the email, please contact support at{" "}
        {LANDING_SUPPORT.phone} (Mon–Fri, 8 AM–9 PM)
      </p>

      <div className={LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.actions}>
        <Link
          to="/classes"
          className={`inline-flex items-center justify-center ${LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.secondaryButton}`}
        >
          Back to class list
        </Link>
        <Link
          to="/auth/signin"
          className={`inline-flex items-center justify-center ${LANDING_PAYMENT_SUCCESS_TYPOGRAPHY.primaryButton}`}
        >
          View Class
        </Link>
      </div>
    </div>
  );
}
